module.exports = __webpack_public_path__ + "static/media/cuadro-1-analisis.0297fd94.png";